import React, { useReducer } from 'react'
import { HiOutlineDocumentText } from "react-icons/hi";
import {CircularProgress,
    List,
    ListItem,
    Divider, Skeleton } from '@mui/material';

export default function DocumentsInnerComponent(props) {
    const [loading, updateLoading] = useReducer((state, action) => {
        if (action.type === 'add') {
            return [...state, action.id]
        } else if (action.type === 'remove') {
            return state.filter((id) => id !== action.id)
        }

        return state;
    }, [])

    const generateDocumentsList = (docs: any[], loading: any[]) => {
        let elements: any[] = [];

        docs.forEach((document, index, list) => {
            elements.push(<ListItem key={"documentId" + index} className="pb-doc-row">
                <div className="pb-doc-row-inner">
                    <span className="pb-doc-icon"><HiOutlineDocumentText /></span>
                    <div className="pb-doc-name">{document.documentTemplateName}</div>
                    {loading.includes(document.documentUrl) ? <CircularProgress size={20} style={{ marginRight: 10 }} className="text-primary text-center center" /> : <div><a className="pb-doc-pill" href={undefined} onClick={() => {
                        updateLoading({ type: 'add', id: document.documentUrl })
                        setTimeout(() => {
                            props.handleViewDocument(document.documentUrl, () => {
                                updateLoading({ type: 'remove', id: document.documentUrl })
                            })
                        }, 50)
                    }}>View</a></div>}
                </div>
            </ListItem>);

        })

        return elements;
    }

    return (<>
        {props.isBusy ?
            // Skeleton rows in the shape of the list, so the popover opens at its size instead of with a spinner.
            <div className="pb-doc-skeleton">
                {[0, 1, 2].map((i) => (
                    <div key={i}>
                        <Skeleton animation="wave" variant="text" width={i === 1 ? "55%" : "70%"} height={18} />
                        <Skeleton animation="wave" variant="rounded" width={70} height={30} style={{ borderRadius: 999 }} />
                    </div>
                ))}
            </div>
            : <React.Fragment>
                <List
                    component="div"
                    className="pb-doc-list">
                    {props.lotDocuments instanceof Array && props.lotDocuments.length > 0 ?
                        generateDocumentsList(props.lotDocuments, loading)
                        : <div className="pb-doc-empty">No documents</div>
                    }
                </List>
            </React.Fragment>}
    </>);
}